const { VITE_API_FETCH_TIMEOUT_SEC } = import.meta.env;

export const FETCH_TIMEOUT = VITE_API_FETCH_TIMEOUT_SEC || 3000;
export const TIMEOUT_ERROR = 'TIMEOUT';
